// hooks/useFormatDate.js
import { useCallback } from 'react';

const useFormattedDate = () => {
  const formatDate = useCallback((dateValue, options = {}) => {
    if (!dateValue) return 'Not provided';
    
    const date = new Date(dateValue);
    if (isNaN(date)) return 'Invalid date';

    const defaultOptions = {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
    };

    return new Intl.DateTimeFormat('en-US', { ...defaultOptions, ...options }).format(date);
  }, []);

  const formatTime = useCallback((dateValue, formatType = 'user-friendly') => {
    if (!dateValue) return 'Not provided';

    const date = new Date(dateValue);
    if (isNaN(date)) return 'Invalid date';

    if (formatType === 'user-friendly') {
      // More user-friendly format: "2:30 PM" or "14:30"
      const options = {
        hour12: true,
        hour: 'numeric',
        minute: '2-digit',
      };
      return new Intl.DateTimeFormat('en-US', options).format(date);
    } else if (formatType === 'with-seconds') {
      // With seconds: "2:30:45 PM" or "14:30:45"
      const options = {
        hour12: true,
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
      };
      return new Intl.DateTimeFormat('en-US', options).format(date);
    } else {
      // 24-hour format (original): "14:30:45"
      const options = {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      };
      return new Intl.DateTimeFormat('en-US', options).format(date);
    }
  }, []);

  const formatDateTime = useCallback((dateValue) => {
    if (!dateValue) return 'Not provided';

    const date = new Date(dateValue);
    if (isNaN(date)) return 'Invalid date';

    const options = {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    };

    return new Intl.DateTimeFormat('en-US', options).format(date);
  }, []);

  return { formatDate, formatTime, formatDateTime };
};

export default useFormattedDate;